import React, {FC} from 'react';

import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets';
import {ImplementMethodButton} from 'common/onboarding/immersive-onboarding/components/implement-method-button';
import {ImplementMethodGrid} from 'common/onboarding/immersive-onboarding/components/implement-method-grid';
import {TrackingEvent, TrackingProperty, trackOnboardingEvent} from 'common/onboarding/immersive-onboarding/tracking';
import {useTranslation} from 'common/i18n/hooks';
import common from 'iron/common/onboarding/immersive-onboarding/steps/common.module.styl';

export const ExistingTools: FC = () => {
  const {t} = useTranslation();

  const handleClick = (buttonTitle: string) => {
    trackOnboardingEvent(TrackingEvent.LinkClicked, {
      [TrackingProperty.LinkSource]: buttonTitle,
    });
  };

  return (
    <ImplementMethodGrid className={common.mt42}>
      <ImplementMethodButton
        title={`Segment`}
        url='https://developer.mixpanel.com/docs/segment'
        imgSrc={IMMERSIVE_ASSETS.segment}
        highlight={t(`onboarding.implement.popular`)}
        onClick={() => handleClick(TrackingEvent.SegmentDocLink)}
      />
      <ImplementMethodButton
        title={`BigQuery`}
        url={`https://docs.mixpanel.com/docs/tracking/data-warehouse?dwh=bigquery`}
        imgSrc={IMMERSIVE_ASSETS.bq}
        onClick={() => handleClick(TrackingEvent.BigQueryDocLink)}
      />
      <ImplementMethodButton
        title={`Snowflake`}
        url={`https://docs.mixpanel.com/docs/tracking-methods/data-warehouse?dwh=snowflake`}
        imgSrc={IMMERSIVE_ASSETS.snowflake}
        onClick={() => handleClick(TrackingEvent.SnowflakeDocLink)}
      />
      <ImplementMethodButton
        title={`RudderStack`}
        url={`https://developer.mixpanel.com/docs/rudderstack`}
        imgSrc={IMMERSIVE_ASSETS.rudderstack}
        onClick={() => handleClick(TrackingEvent.RudderStackDocLink)}
      />
      <ImplementMethodButton
        title={`Redshift`}
        url={`https://docs.mixpanel.com/docs/tracking-methods/data-warehouse?dwh=redshift`}
        imgSrc={IMMERSIVE_ASSETS.redshift}
        onClick={() => handleClick(TrackingEvent.RedshiftDocLink)}
      />
      <ImplementMethodButton
        title={t(`onboarding.implement.more-options`)}
        url={`https://docs.mixpanel.com/docs/tracking-methods/choosing-the-right-method`}
        imgSrc={IMMERSIVE_ASSETS.more}
        onClick={() => handleClick(TrackingEvent.MoreSdksDocLink)}
      />
    </ImplementMethodGrid>
  );
};
